<div *ngIf="contactFields">
  <div class="add-contact-report" (click)="editContacts()" *ngIf="contactInfo.length === 0">
    <a><mat-icon svgIcon="add-fill"></mat-icon>{{ 'searchContact.addContact' | xTranslate }}</a>
  </div>
  <div class="add-contact-banner" *ngIf="contactInfo.length > 0">
    <div *ngFor="let contact of contactInfo; let i = index" class="contact-card">
      <div class="circle-container" [ngStyle]="{ 'background-color': i | getColor }">
        <span> {{ contact.name | getContactInitials }}</span>
      </div>
      <div class="content-wrapper">
        <div class="contact-title" *ngIf="contact.name">{{ contact.name }}</div>
        <div class="email" *ngIf="contact.role">{{ contact.role }}</div>
        <div class="email" *ngIf="contact.phone">{{ contact.phone }}</div>
        <div class="email" *ngIf="contact.email">{{ contact.email }}</div>
      </div>
      <div>
        <div class="contact-bgcolor">
          <div class="contactCheck">
            <mat-icon
              class="contact-close"
              color="y-icon"
              svgIcon="edit"
              (click)="contactOverlay.toggle($event); editNamePhoneContact(contact)"
            ></mat-icon>
            <mat-icon
              class="contact-close"
              color="y-icon"
              svgIcon="close"
              (click)="removeContact(contact.id)"
            ></mat-icon>
          </div>
        </div>
      </div>
      <p-overlayPanel #contactOverlay [dismissable]="true" appendTo="body" styleClass="contact-settings-overlay">
        <rep-contact-settings
          [reportId]="reportId"
          [selectedContact]="selectedContact"
          [phoneCatalog]="phoneCatalog"
          (refreshContacts)="getContacts()"
        ></rep-contact-settings>
      </p-overlayPanel>
    </div>
    <div class="edit-icon" (click)="editContacts()">
      <a><mat-icon class="contact-close" svgIcon="edit"></mat-icon>{{ 'searchContact.edit' | xTranslate }}</a>
    </div>
  </div>
</div>
